import { Paragraph } from '@zillow/constellation-10';

const ConfirmStartPage = (): JSX.Element | null => (
  <>
    <Paragraph textStyle="body-lg-bold">Please answer the following questions</Paragraph>
    <Paragraph>We will ask a few questions to complete your verification.</Paragraph>
    <Paragraph>
      You have <strong>5 minutes</strong> to complete this step. Please do not reload the page as you answer the
      questions.
    </Paragraph>
  </>
);

export default ConfirmStartPage;
